import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20flowing%20fabric%20in%20warm%20blush%20and%20cream%20tones%20draped%20elegantly%2C%20minimalist%20luxurious%20textile%20photography%2C%20gentle%20diffused%20lighting%2C%20dreamy%20feminine%20aesthetic%2C%20soft%20focus%20background%2C%20editorial%20quality&width=1920&height=600&seq=cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/80 to-primary-600/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          找到属于你的那条内裤
        </h2>
        <p className="text-white/85 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          舒适与时尚从不矛盾。浏览我们的完整选购指南，从材质到款式，从尺码到品牌，全方位帮你做出最佳选择。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center px-8 py-3.5 rounded-full bg-white text-primary-600 font-medium text-sm hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-8 py-3.5 rounded-full border border-white/50 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}